<template>
    <div class="home-page">
        <leftnav class="fl"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <!-- <govheader></govheader> -->
            <div class="index_left_centerpage">
                <div class="whitebox height-90vh ">
                    <div class="search-banner">
                        <h1 class="text-center title">企业战略投资部的数智化助手</h1>
                        <div class="search-input-box">
                            <div class="search-type">
                                <span class="type-text" :class="searchtype == 2 ? 'active' : ''"
                                     @click="searchtype = 2">搜产业链</span>
                                     <span class="type-text" :class="searchtype == 3 ? 'active' : ''"
                                    @click="searchtype = 3">搜研究报告</span>
                                <span class="type-text" :class="searchtype == 1 ? 'active' : ''"
                                    @click="searchtype = 1">搜重点企业</span>
                            </div>
                            <input class="search-input" :placeholder="placeholder" v-model="kw"
                                @keyup.enter="searchkwfun" />
                            <button class="search-btn" @click="searchkwfun">搜索</button>
                        </div>
                        <div class="close-btn" @click="routerself('/totalEnterprises')">
                            <i class="iconfont el-icon-close"> </i>
                        </div>
                        <!-- <ul class="menu">
                            <li @click="logout()">退出登录</li>
                            <li @click="routerself('/userFocus')">关注领域</li>
                        </ul> -->
                    </div>
                    <div class="content-box">
                        <div class="w95mg content">
                            
                            <div class="content-item" style="width: 49%;">
                                <!-- <div class="con-max-height" >
                                    <div class="content-item-title">最新行业报告</div>
                                    <ul class="rpt">
                                        <li @click="handlerRouter('rpt',list)" :key="ind" v-for="(list, ind) in reportList_all" v-show="ind < 6">{{ list.title }} <span
                                                class="fr mr-1"> > </span></li>
                                    </ul>
                                </div> -->
                                <div class="con-max-height">
                                    <div class="content-item-title">重点行业报告推荐</div>
                                    <ul class="rpt">
                                        <li @click="handlerRouter('rpt',list)" :key="ind" v-for="(list, ind) in reportList" v-show="ind < 6">{{ list.title }} <span
                                                class="fr mr-1"> > </span></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="content-item" style="width: 49%;">
                                <!-- <div>
                                    <div class="content-item-title">最新产业链</div>
                                    <ul class="lian">
                                        <li @click="handlerRouter('chain',list)" class="curp" :key="ind" v-for="(list, ind) in chainlist_all" v-show="ind < 16">
                                            {{ list.chainName }}</li>
                                    </ul>
                                </div> -->
                                <div>
                                    <div class="content-item-title">重点产业链推荐</div>
                                    <ul class="lian">
                                        <li @click="handlerRouter('chain',list)" class="curp" :key="ind" v-for="(list, ind) in chainlist" v-show="ind < 16">
                                            {{ list.chainName }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="w95mg pb-2">
                            <div class="content-item " style="width: 100%;">
                                <div>
                                    <div class="content-item-title">对标行业龙头企业推荐 </div>
                                    <div class="land-ecahrt-title w95mg ">
                                        <span class="title fl" @click="handler_enterprise_type(9, 'lm')"
                                            :class="lm_enterprise_type == 9 ? 'current' : ''">上市公司</span>
                                        <span class="title fl" @click="handler_enterprise_type(0, 'lm')"
                                            :class="lm_enterprise_type == 0 ? 'current' : ''">央企</span>
                                        <span class="fr mt-1 mr curp mr-1" v-show="lm_enterprise_type == 9"
                                            @click="routerblank('/enterpriseList?type=9&Pt=1')">查看更多 > </span>
                                        <span class="fr mt-1 mr curp mr-1" v-show="lm_enterprise_type == 0"
                                            @click="routerblank('/totalEnterprises?type=0&tag=A020131')">查看更多 > </span>
                                    </div>
                                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table  w95mg"
                                        v-show="lm_enterprise_type == 9">
                                        <tr>
                                            <th>企业名称</th>
                                            <th>所属产业</th>
                                            <th>画像标签</th>
                                            <th>地区</th>
                                        </tr>
                                        <tr :key="ind" v-for="(list, ind) in ss_enterprise_list" v-show="ind < 5">
                                            <td class="title"
                                                @click="routerlinkid('/enterprises', list.stockCode, curindex)">
                                                {{ list.title }}</td>
                                            <td class="conpanytags hastag">
                                                <span class="span-tag" v-for="(item, i) in list.notionlist" :key="i"
                                                    v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td class="conpanytags notiontags">
                                                <span class="span-tag" v-for="(item, i) in list.taglist"
                                                    :key="item.id + '' + i" v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td>{{ list.area }}</td>
                                        </tr>
                                    </table>
                                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table  w95mg"
                                        v-show="lm_enterprise_type == 0">
                                        <tr>
                                            <th>企业名称</th>
                                            <th>所属产业</th>
                                            <th>画像标签</th>
                                            <th>地区</th>
                                        </tr>
                                        <tr :key="ind" v-for="(list, ind) in yq_enterprise_list" v-show="ind < 5">
                                            <td class="title"
                                                @click="routerlinkid('/enterprises', list.stockCode, curindex)">
                                                {{ list.title }}</td>
                                            <td class="conpanytags hastag">
                                                <span class="span-tag" v-for="(item, i) in list.notionlist" :key="i"
                                                    v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td class="conpanytags notiontags">
                                                <span class="span-tag" v-for="(item, i) in list.taglist"
                                                    :key="item.id + '' + i" v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td>{{ list.area }}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div>
                                    <div class="content-item-title">优质投资标的推荐</div>
                                    <div class="land-ecahrt-title w95mg ">
                                        <span class=" title fl" @click="handler_enterprise_type(2, 'sm')"
                                            :class="sm_enterprise_type == 2 ? 'current' : ''">创投企业</span>
                                        <span class="title fl" @click="handler_enterprise_type(0, 'sm')"
                                            :class="sm_enterprise_type == 0 ? 'current' : ''">专精特新企业</span>
                                        <span class="fr mt-1 mr curp mr-1" v-show="sm_enterprise_type == 2"
                                            @click="routerblank('/enterpriseList?type=2&Pt=2')">查看更多 > </span>
                                        <span class="fr mt-1 mr curp mr-1" v-show="sm_enterprise_type == 0"
                                            @click="routerblank('/totalEnterprises?type=0&tag=A080101')">查看更多 > </span>
                                    </div>
                                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table  w95mg"
                                        v-show="sm_enterprise_type == 2">
                                        <tr>
                                            <th>企业名称</th>
                                            <th>所属产业</th>
                                            <th>画像标签</th>
                                            <th>地区</th>
                                        </tr>
                                        <tr :key="ind" v-for="(list, ind) in cx_enterprise_list" v-show="ind < 5">
                                            <td class="title"
                                                @click="routerlinkid('/enterprises', list.stockCode, curindex)">
                                                {{ list.title }}</td>
                                            <td class="conpanytags hastag">
                                                <span class="span-tag" v-for="(item, i) in list.notionlist" :key="i"
                                                    v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td class="conpanytags notiontags">
                                                <span class="span-tag" v-for="(item, i) in list.taglist"
                                                    :key="item.id + '' + i" v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td>{{ list.area }}</td>
                                        </tr>
                                    </table>
                                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table  w95mg"
                                        v-show="sm_enterprise_type == 0">
                                        <tr>
                                            <th>企业名称</th>
                                            <th>所属产业</th>
                                            <th>画像标签</th>
                                            <th>地区</th>
                                        </tr>
                                        <tr :key="ind" v-for="(list, ind) in zj_enterprise_list" v-show="ind < 5">
                                            <td class="title"
                                                @click="routerlinkid('/enterprises', list.stockCode, curindex)">
                                                {{ list.title }}</td>
                                            <td class="conpanytags hastag">
                                                <span class="span-tag" v-for="(item, i) in list.notionlist" :key="i"
                                                    v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td class="conpanytags notiontags">
                                                <span class="span-tag" v-for="(item, i) in list.taglist"
                                                    :key="item.id + '' + i" v-show="i < 18"
                                                    @click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name)">{{
                                                    item.name }}</span>
                                            </td>
                                            <td>{{ list.area }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import router from "../../../router";
export default {
    name: 'home-page',
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse'])
    },

    data() {
        return {
            curWebsite: this.$api.getWebsiteType(),
            userdata: {},
            kw: '',
            searchtype: 1,
            placeholder: '请输入企业名称',
            enterpriseList: [],
            reportList: [],
            reportList_all: [],
            chainlist: [],
            chainlist_all: [],
            ajaxurlData: {land:"",invest:""},
            land_invest_type:'',
            ajaxurl:'',
            cur_list:{},
            sm_enterprise_type:2,
            lm_enterprise_type:9,
            zj_enterprise_list:[], //专精特新
            cx_enterprise_list:[], //创投企业
            ss_enterprise_list:[], //上市公司
            yq_enterprise_list:[], //央企
        }
    },
    watch: {
        searchtype: {
            handler(newValue, oldValue) {
                console.log(newValue, oldValue);
                switch (newValue) {
                    case 1:
                        this.placeholder = '请输入企业名称';
                        break;
                    case 2:
                        this.placeholder = '请输入要搜索的产业链';
                        break;
                    case 3:
                        this.placeholder = '请输入报告名称';
                        break;
                    default:
                        this.placeholder = '请输入内容';
                }
            }
        }
    },
    created() {
        document.title = this.curWebsite.shortname + ' - 首页';
        this.userdata = this.getuseriformation();
        
    },
    mounted() {
        this.get_enterprise_list(0,'sm');
        this.get_enterprise_list(0,'lm');
        this.get_enterprise_list(2,'sm');
        this.get_enterprise_list(9,'lm');
        this.getchainlist('all');
        this.getRptList('all');
    },
    methods: {
        handlerRouter(type,list) {
                switch (type) {
                    case 'chain':
                        if(list.chainId){
                            this.routerlinkid('/chain',list.chainId);
                        }
                        break;
                    case 'rpt':
                    if(this.userdata.token){
				        window.open(list.url+'&token='+this.userdata.token);
                    }else{
                        this.routerblank('/reportDetail?id='+ list.id);
                    }
                        break;
                    }
        },
        handler_enterprise_type(type,label) {
            if(label=='sm'){
                this.sm_enterprise_type = type;
            }else if(label=='lm'){
                this.lm_enterprise_type = type;
            }
        },
        get_enterprise_list(type,label) {
            if(label=='sm'){
                if(type == 0){
                    this.ajaxsearchcompany(1, type,'A080101');
                }else{
                    this.ajaxsearchcompany(1, type);
                }
            }else if(label=='lm'){
                if(type == 0){
                    this.ajaxsearchcompany(1, type,'A020131');
                }else{
                    this.ajaxsearchcompany(1, type);
                }
            }
        },
        //获取企业列表
        ajaxsearchcompany(pages, searchtype,tag) {
				console.log('搜索企业',pages, searchtype,tag);
				// this.bus.$emit('loading', true);
				var _this = this; 
                let tagaja =this.splicing('tag', tag);
				var ajaxurl = this.$api.cyl.enterprise.list()+ '?type=' + searchtype + tagaja;
				// console.log(ajaxurl)
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('企业列表',ajaxurl, res.data);
					if (res.data.success) {
						var dataenterlist = res.data.list;
                        for (var i = 0; i < res.data.list.length; i++) {
                        dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[i].notionCode, 'notionsort');
                        dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i].tagCode);
                    }
                        if(searchtype == 9){
                            _this.ss_enterprise_list = dataenterlist;
                        }else if(searchtype == 0 && tag == 'A020131'){
                            _this.yq_enterprise_list = dataenterlist;
                        }else if (searchtype == 2){
                            _this.cx_enterprise_list = dataenterlist;
                        }else if (searchtype == 0 && tag == 'A080101'){
                            _this.zj_enterprise_list = dataenterlist;
                        }
                        console.log('企业列表',_this.ss_enterprise_list,_this.yq_enterprise_list,_this.cx_enterprise_list,_this.zj_enterprise_list);
						// _this.bus.$emit('loading', false);
						
					}  
				}).catch(function(error) {});
				// console.log(datas);  
			},
        //投资动态跳转到投资项目库页面
        openProjectLink(url){
            if(url && url!= ''){
                    window.open(url); //研究报告库外部跳转
            } 
        },
        //获取产业链列表
        getchainlist(type) {
            var _this = this;
                let popupChainList =  this.userdata.popupChainList?this.userdata.popupChainList:'';
                if (type == "all") {
                    popupChainList = '';
                }else{
                    popupChainList = popupChainList;
                }   
                console.log('产业链列表',type,'----', popupChainList,this.userdata.popupChainList);
                var ajaxurl = this.$api.cyl.chain.list()  +'?pupupChainList='+ popupChainList+"&pageSize=16";
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {
                if (res.data.success) {
                    console.log('产业链', res, ajaxurl,_this.userdata.popupChainList);
                    // if (type == "all") {
                    //     _this.chainlist_all = res.data.list;
                    //     _this.getchainlist();
                    // } else {
                        _this.chainlist = res.data.list;
                    // }
                    // _this.bus.$emit('loading', false);
                    // setTimeout(function () {
                        _this.bus.$emit('loading', false);
                    // }, 3000);
                } else {

                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        //获取报告列表
        getRptList(type) {
            var _this = this;
            let reportIdList = this.userdata.popupReportList?this.userdata.popupReportList:'';
            if (type == "all") {
                reportIdList = '';
            }else {
                reportIdList = reportIdList;
            }
            this.bus.$emit('loading', true);
            console.log('111报告',type,'-----', reportIdList,'=----===',this.userdata.popupReportList);
            var ajaxurl = this.$api.cyl.report.list() + '?page=1'+'&reportIdList='+reportIdList;
            this.$axios.get(ajaxurl).then(function (res) {
                if (res.data.success) {
                    console.log('报告列表', res, ajaxurl);
                    if (type == "all") {
                        _this.reportList_all = res.data.list;
                        _this.getRptList();
                    }else{
                        _this.reportList = res.data.list;
                    }

                } else {

                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        searchkwfun() {
            console.log('搜索',this.kw,this.searchtype);
            let searchtype = this.searchtype;
            switch (searchtype) {
                case 1:
                    this.routerblank('/totalSearch?kw='+ this.kw);
                    break;
                case 2:
                this.routerblank('/allchain?kw='+this.kw);
                    break;
                case 3:
                this.routerblank('/report?kw='+this.kw);

                default:
                    break;
            }
        },
    },
}
</script>

<style lang="scss">

.height-90vh {
    min-height: 90vh
}
.con-max-height{
    // height: 300px;
    // overflow: hidden;
}
.home-page {
    .enterprise_table {
        td {
            padding: 10px 10px 3px 10px;
            width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
           .curp {
                display: inline-block;
                min-width: 140px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

            }
            &.enterprise_name {
                width: 200px;
            }
            &.title {
                padding: 10px;
            }
        }
    }

    .index_left_centerpage {
        padding: 0;
    }
}

.search-banner {
    padding: 0 20px;
    height: 270px;
    background: url('../../../assets/images/zs_banner.png') no-repeat;
    background-size: cover;
    position: relative;
    .close-btn{
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        padding: 5px 10px;
        background-color: #f39800;
        &:hover{
            background-color: #f39a00be;
            color: #fff;
        }
        i{
            font-size: 20px;
            color: #fff;
        }
    }
    .menu{
    position: absolute;
    right: 0;
    top: 0;
    background: rgba(255, 255, 255, 0.4);
    width: 140px;
    li{
        color: #fff;
        font-weight: bold;
        padding: 0 20px;
        width: 100px;
        text-align: center;
        line-height: 42px;
        cursor: pointer;
        &:hover{
            background: #f39800;
            color: #fff;
        }
    }
}
    .title {
        color: #fff;
        padding: 55px 0 25px;
    }

    .search-type {
        width: 70%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        .type-text {
            cursor: pointer;
            color: #fff;

            &.active {
                font-weight: bold;

                &::after {
                    content: '';
                    display: block;
                    width: 50%;
                    height: 2px;
                    background-color: #fff;
                    margin-top: 5px;
                    margin-left: 25%;
                }
            }
        }
    }
}

.search-input-box {
    width: 600px;
    margin: 0 auto;

    .search-btn {
        display: inline-block;
        background-color: #f39800;
        color: #fff;
        cursor: pointer;
        border-color: #f39800;
        vertical-align: middle;
        border-radius: 4px;
        padding: 0 20px;
        white-space: nowrap;
        height: 40px;
        line-height: 40px;
        border-radius: 0 4px 4px 0;
    }

    .search-input {
        margin-top: 20px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px 0 0 4px;
        width: 500px;
        padding: 0 15px;
    }
}

.content-box {

    background: url('../../../assets/images/homeCbg.png') no-repeat;

    .content {
        max-width: 1577px;
        padding: 20px 0;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }

    .content-item {
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        width: calc(100% / 3 - 15px);
        // height: 600px;
        background-color: #fff;
        margin: 10px 0;
        border-radius: 10px;
        padding-bottom: 20px;

        &.item1 {
            width: 45%;
        }

        .content-item-title {
            font-weight: bold;
            text-shadow: 2px 5px 10px rgba(51, 115, 235, 0.3);
            padding: 20px;

            &::before {
                content: '';
                display: inline-block;
                width: 4px;
                height: 15px;
                background-color: #3A66BE;
                margin-right: 10px;
            }
        }
    }

    .lian {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        // height: 235px;
        overflow: hidden;

        li {
            width: calc(100% / 2 - 26px);
            height: 36px;
            line-height: 36px;
            margin-left: 26px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &::before {
                content: '';
                background: url('../../../assets/images/lian-icon.png') no-repeat;
                background-size: 100% 100%;
                display: inline-block;
                width: 25px;
                height: 18px;
                margin-right: 30px;
                position: relative;
                top: 8px;
                left: 20px;
            }
        }

    }

    .rpt {
        margin-left: 20px;
        line-height: 38px;

        li {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
            width: 95%;
            height: 40px;
            line-height: 40px;
            color: #043db1;
            margin-bottom: 10px;
            cursor: pointer;
            text-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            span {
                color: #043db1;
            }

            //渐变色
            background: linear-gradient(to right, #eff4ff, #809cd4);

            &:hover {

                background: linear-gradient(to right, #809cd4, #eff4ff);
                color: #fff;

                span {
                    color: #043db1;
                }

                &::before {
                    content: '';
                    background: url('../../../assets/images/home-list-hover.png') no-repeat;
                    background-size: 100% 100%;
                    display: inline-block;
                    width: 25px;
                    height: 25px;
                    margin-right: 30px;
                    position: relative;
                    top: 8px;
                    left: 20px;
                }
            }

            &::before {
                content: '';
                background: url('../../../assets/images/home-list.png') no-repeat;
                background-size: 100% 100%;
                display: inline-block;
                width: 25px;
                height: 25px;
                margin-right: 30px;
                position: relative;
                top: 8px;
                left: 20px;
            }
        }
    }
}
</style>